import React from 'react';
import StatusBanner from '../ui/StatusBanner';

function ReturnedItemsBanner({ items = [] }) {
  if (!items.length) {
    return null;
  }

  const firstItem = items[0] || null;

  return (
    <div style={{ margin: '0 0 16px 0' }}>
      <StatusBanner
        kind="warning"
        message={(
          <>
            <strong>{items.length} item{items.length !== 1 ? 's' : ''} returned for revision</strong>
            {firstItem?.decisionNote ? (
              <p style={{ margin: '4px 0 0', fontWeight: 400 }}>Note: {firstItem.decisionNote}</p>
            ) : null}
            <p style={{ margin: '4px 0 0', fontWeight: 400, fontSize: '0.85em' }}>
              Please review and resubmit the affected {firstItem?.approvalDomainLabel || 'item'}.
            </p>
          </>
        )}
      />
    </div>
  );
}

export default ReturnedItemsBanner;
